import { Component, HostListener, inject } from '@angular/core';
import { SidebarComponent } from "../../common/components/sidebar/sidebar.component";
import { NavbarComponent } from "../../common/components/navbar/navbar.component";
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-dashboard',
  imports: [
    SidebarComponent,
    NavbarComponent,
    RouterModule,
    CommonModule
  ],
  host: {
    class: 'flex h-screen overflow-hidden',
  },
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
})
export class DashboardComponent {
  
  showSidebar: boolean = true;

  
  ngOnInit() {
    // Establecer el estado inicial del sidebar basado en el tamaño de la ventana
    this.showSidebar = window.innerWidth >= 968;
    
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.showSidebar = window.innerWidth >= 968;
  }
}
